/**
 * Questionnaire Organisation & Public Questionnaire Formation endpoints
 */

export const questionnaireOrganisationEndpoints = {
  // Sprint 9 — Reponses questionnaire
  reponses: {
    create: () => '/api/questionnaire-organisation/reponses',
    byQuote: (quoteId) => `/api/questionnaire-organisation/reponses/by-quote/${quoteId}`,
    detail: (id) => `/api/questionnaire-organisation/reponses/${id}`,
    update: (id) => `/api/questionnaire-organisation/reponses/${id}`,
    sendLink: (id) => `/api/questionnaire-organisation/reponses/${id}/send-link`,
    pdf: (id) => `/api/questionnaire-organisation/reponses/${id}/pdf`,
  },
  // Public (token)
  public: {
    get: (token) => `/api/public/questionnaire-organisation?token=${token}`,
    preview: () => '/api/public/questionnaire-organisation/preview',
    submit: () => '/api/public/questionnaire-organisation',
    edit: () => '/api/public/questionnaire-organisation/edit',
    updateDossierInfo: () => '/api/public/questionnaire-organisation/dossier-info',
    updatePostSubmission: () => '/api/public/questionnaire-organisation/post-submission',
    pdf: (token) => `/api/public/questionnaire-organisation/pdf?token=${token}`,
    uploadOpcoDocument: () => '/api/public/questionnaire-organisation/opco-document',
    uploadAttestation: () => '/api/public/questionnaire-organisation/upload-attestation',
    deleteAttestation: () => '/api/public/questionnaire-organisation/delete-attestation',
    reponseDocuments: (token) => `/api/public/questionnaire-organisation/reponse-documents?token=${encodeURIComponent(token)}`,
    uploadReponseDocuments: () => '/api/public/questionnaire-organisation/reponse-documents',
    downloadReponseDocument: (token, id) => `/api/public/questionnaire-organisation/reponse-documents/${id}/download?token=${encodeURIComponent(token)}`,
    deleteReponseDocument: () => '/api/public/questionnaire-organisation/reponse-documents/supprimer',
    getListeStagiaires: (token) => `/api/public/questionnaire-organisation/liste-stagiaires?token=${token}`,
    submitListeStagiaires: () => '/api/public/questionnaire-organisation/liste-stagiaires',
  },
}

export const publicQuestionnaireFormationEndpoints = {
  get: (token) => `/api/public/questionnaire-formation?token=${encodeURIComponent(token)}`,
  submit: () => '/api/public/questionnaire-formation',
}
